import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from '@weezevent/nacre';

export default function BatchModal({ show, onClose, onAccept, title, body, labelAccept, labelReturn }) {
    if (!show) {
        return null;
    }

    return (
        <Modal
            size="mini"
            open
            onClose={onClose}
            title={title}
            submitButton={<Button primary onClick={onAccept} label={labelAccept} />}
            cancelButton={<Button className={'partner-continue-button'} onClick={onClose} label={labelReturn} />}
        >
            {body}
        </Modal>
    );
}

BatchModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    labelAccept: PropTypes.string.isRequired,
    labelReturn: PropTypes.string.isRequired
};
